export const messages = {
    "shared-link.footer.link.install": "Опитайте {brandName} безплатно",
    "shared-link.footer.link.mobile": "{brandName} за мобилен телефон",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Защитени данни",
    "shared-link.password-dialog-box.message": "Посочете паролата за достъп до споделените данни",
    "shared-link.password-dialog-box.hint.password": "Парола",
    "shared-link.password-dialog-box.message.invalid-password": "Паролата е неправилна",
    "shared-link.form.button.open": "Отваряне",
    "shared-link.page-not-found.title": "Страницата не е открита",
    "shared-link.page-not-found.message.main": "Страницата, която търсите, не е намерена.",
    "shared-link.page-not-found.message.description": "Връзката може да е остаряла или може да сте въвели адреса неправилно.",
    "shared-link.page-not-found.message.error": "Код на грешка: 404",
    "shared-link.restore-file.label.size": "Размер",
    "shared-link.restore-file.button.restore": "Изтегляне",
    "shared-link.links-table.column.name": "Име",
    "shared-link.links-table.column.size": "Размер",
    "shared-link.links-table.action.restore": "Изтегляне",
    "shared-link.links-table.action.restore-all": "Изтегляне на всички",
    "shared-link.side-bar.selected.title:plural": "{count} избрани елемента | {count} избран елемент | {count} избрани елемента",
    "shared-link.links-table.label.size": "Размер",
    "shared-link.links-table.message.empty-folder": "Тази папка е празна"
};
